import {SHOW_MODAL} from '../actions/show-modal';
import {HIDE_MODAL} from '../actions/hide-modal';

const openedModals = {};

export const onModalCloseMiddleware = () => {
  return next => action => {
    if (action.type === SHOW_MODAL) {
      const {__resolvePromise__, type} = action.payload;
      if (__resolvePromise__) {
        openedModals[type] = __resolvePromise__;
        delete action.payload.__resolvePromise__;
      }
    }

    if (action.type === HIDE_MODAL) {
      const {__resolveProps__, type} = action.payload;
      if (openedModals[type]) {
        openedModals[type](__resolveProps__);
        delete openedModals[type];
      }
    }

    next(action);
  };
};
